module.exports = __webpack_public_path__ + "static/logo-47d06895e0d4f3228a9e8b80c544e80b.svg";